// extracted by mini-css-extract-plugin
export default {"loading":"LoginWrapper_loading__uiblf"};